import React from "react";
import {useAppStore} from "../../../common/app.store.consumer";
import {ReportChartComponent} from "../types/report.chart.component";

const ReportDebugPanel: React.FC<ReportChartComponent> = useAppStore()((props: ReportChartComponent) => {
	const store = props.appStore.reportPageStore;
	return (
		<div>
			<table>
				<thead>
					<tr>
						<th>Characteristic</th>
						<th>Correct answers</th>
						<th>Score %</th>
						<th>Score band</th>
						<th>Paragraph order</th>
					</tr>
				</thead>
				<tbody>
					{store.questionnaireAnswerSheetDetails.debugPanelInfo.map((dp) => (
						<tr key={dp.taxonomyId}>
							<td>{dp.taxonomy}</td>
							<td>
								{dp.correctAnswersCount}/{dp.allAnswersCount}
							</td>
							<td>{(dp.score * 100).toFixed(0)}</td>
							<td>{dp.scoreBand}</td>
							<td>{dp.paragraphOrder}</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
});

export default ReportDebugPanel;
